import { token } from '@atlaskit/tokens'
import { css } from '@emotion/react'

export const modalCss = {
  wrapper: css({
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    justifyContent: 'space-between',
  }),
  heading: css({
    padding: `${token('space.300', '24px')} ${token('space.300', '24px')} 22px`,
  }),
  body: css({
    flexGrow: 1,
    padding: `${token('space.025', '2px')} ${token('space.300', '24px')}`,
  }),
  footer: css({
    display: 'flex',
    justifyContent: 'flex-end',
    gap: token('space.100', '8px'),
    padding: `22px ${token('space.300', '24px')} ${token('space.300', '24px')}`,
  }),
}
